import { Timestamp } from 'firebase/firestore';

export const firebaseTimestampToDate = (
  timestamp?: Timestamp | null,
): Date | null => {
  if (!timestamp) {
    return null;
  }

  const date = new Timestamp(timestamp.seconds, timestamp.nanoseconds).toDate();
  return isNaN(date.getTime()) ? null : date;
};
